(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('SurveyResultSearch', SurveyResultSearch);

    SurveyResultSearch.$inject = ['$resource'];

    function SurveyResultSearch($resource) {
        var resourceUrl =  'api/_search/survey-results/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
